module.exports = __webpack_public_path__ + "img/dxzk_wx_skm.90d0c3dd.png";